import lab from '../assets/images/developmentalNeurobiology.jpg'
export const latestNews = [
    {
        img:lab,
        desc:"Proteins & fats can drive insulin production for some, paving way for tailored nutrition",
        link:"https://www.sciencedaily.com/releases/2024/07/240702135407.htm" 
    }
]